import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { toggleBreadcrumbs } from 'Store/Breadcrumbs/Breadcrumbs.action';
import { updateMeta } from 'Store/Meta/Meta.action';
import { changeNavigationState } from 'Store/Navigation/Navigation.action';
import NewsletterPage from './NewsletterPage.component';

import { TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';
import { CMS_PAGE } from 'Component/Header/Header.config';
import NewsletterQuery from 'Query/Newsletter.query';
import { fetchQuery } from 'Util/Request';

import { history } from 'Route';
export const mapStateToProps = (state) => ({
    newsletterConfig: state.ConfigReducer.newsletter
});
export const mapDispatchToProps = dispatch => ({
    toggleBreadcrumbs: state => dispatch(toggleBreadcrumbs(state)),
    updateMeta: meta => dispatch(updateMeta(meta)),
    setHeaderState: stateName => dispatch(changeNavigationState(TOP_NAVIGATION_TYPE, stateName))
});

export class NewsletterPageContainer extends PureComponent {
    state = {
        isLoading: true,
        promotion: {}
    }
    componentDidMount() {
        const { toggleBreadcrumbs, setHeaderState, updateMeta } = this.props;
        this._getData();

        toggleBreadcrumbs(false);

        setHeaderState({
            name: CMS_PAGE,
            title: __('Newsletter Subscribe'),
            onBackClick: () => history.goBack()
        });

        updateMeta({ title: __('Newsletter Subscribe') });
    }

    _getData() {
        fetchQuery(NewsletterQuery.getData()).then(
            ({ getNewsletterPageData: promotion }) => this.setState({isLoading: false, promotion}),
            (error) => console.log(error)
        );
    }

    render() {
        return <NewsletterPage { ...this.props } {...this.state} />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewsletterPageContainer);
